(function(){
    'use strict'

    angular
    .module('app.inscripciones')
    .controller('inscripciones.EditPago', EditPago);

    EditPago.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams','ApiBaseService', 'logger', '$location', 'UserInfoService', 'moment'];

    function EditPago($q, $scope, $animationsSrv, $routeParams, ApiBaseService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();

        const MONEDA_COLONES = 1;
        const MONEDA_DOLARES = 2;

        const apiInscripciones = 'api/Inscripciones';

        const ESTADO_PENDIENTE = 1;

        const TIPO_PAGO_EFECTIVO = 3;

        const BANCO_NO_APLICA = 20;

        let vm = this;

        vm.data = {
            eventoId: 0,
            bancoId: 0,
            metodoPagoId: 0,
            fechaDeposito: moment().toDate(),
            precioDescuento: 0
        };

        vm.title = 'Datos de Pago';
        vm.id = $routeParams.id ? $routeParams.id : 0;

        vm.bancos = [];
        vm.eventos = [];
        vm.tiposDeposito = [];
        vm.paquetes = [];

        var permisosInscripciones = UserInfoService.getPermisosInscripciones();

        vm.uiData = {
            fechaDepositoOpened: false,
            puedeCambiarEstado: permisosInscripciones.modificar === true,
            descripcionGuardar: 'Confirmar',
            esOrganizador: UserInfoService.esOrganizador(),
            openFechaDeposito(){
                this.fechaDepositoOpened = !this.fechaDepositoOpened;
            }
        };

        var promiseBancos = getComboData(vm.bancos, 'api/Bancos', null, 'Error al cargar los bancos');
        var promiseEventos = getComboData(vm.eventos, 'api/Eventos/All', null, 'Error al cargar los eventos');
        var promiseTiposDeposito = getComboData(vm.tiposDeposito, 'api/TiposDeposito', null, 'Error al cargar los Tipos de Deposito');

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        get();

        function get(){

            $q.all([promiseBancos, promiseEventos, promiseTiposDeposito])
            .then(function(){

                if(vm.id != 0){
                    ApiBaseService.remoteController = apiInscripciones;
                    var promise = ApiBaseService.getAll([vm.id]);

                    promise
                    .then(function(data){
                        data.precio = getPrecioEvento(data.eventoId);
                        data.bancoId = data.bancoId == null ? 0 : data.bancoId;
                        data.metodoPagoId = data.metodoPagoId == null ? 0 : data.metodoPagoId;
                        data.fechaDeposito = data.fechaDeposito == null ? moment().toDate() : moment(data.fechaDeposito).toDate();
                        data.nombreDepositante = `${data.nombre} ${data.apellidos} ${data.apellido2}`;
                        
                        if(data.paqueteId == 0)
                        {
                            data.montoDeposito = data.montoDeposito == null ? getEvento(data.eventoId).precio : data.montoDeposito;
                        }
                        
                        vm.data = data;

                        var promisePaquetes = getComboData(vm.paquetes, 'api/Paquetes/All-Activos-Evento', [data.eventoId], 'Error al cargar los paquetes');
                        promisePaquetes.then(function(){
                            if(data.paqueteId != 0)
                            {
                                vm.data.paqueteId = data.paqueteId;
                                const precioObj = getPrecioEventoConPaquete(data.eventoId, data.paqueteId, data.cupon);
                                vm.data.precio = precioObj.precioText;
                                vm.data.precioDescuento = precioObj.precioConDescuentoText;
                                vm.data.montoDeposito = data.montoDeposito == null ? precioObj.precio : data.montoDeposito;                                
                            }
                        });
                    })
                    .catch(function(error){
                        switch (error.status) {
                            case 401:
                                logger.error('La sesión ha expirado');
                                break;
                        
                            default:
                                logger.error('Hubo un error al obtener el registro: ' + error.data.Message);
                                break;
                        }
                    });               
                }
            });
        };

        function getMonedaSymbol(monedaId)
        {
            switch (monedaId) {
                case MONEDA_COLONES:
                    return '₡';
                case MONEDA_DOLARES:
                    return '$';
                default:
                    return '';
            }
        };

        function getPrecioEvento(eventoId)
        {
            const evento = getEvento(eventoId);

            let monedaSymbol = getMonedaSymbol(evento.monedaId);

            return `${monedaSymbol} ${evento.precio}`;
        };

        function getPrecioEventoConPaquete(eventoId, paqueteId, cupon)
        {
            if(eventoId != 0 && paqueteId != 0)
            {
                const paquete = vm.paquetes.find((e)=>{return e.id == paqueteId;});
                const evento = getEvento(eventoId);

                let montoCupon = 0;
                let montoConDescuento = 0;

                if(cupon != null)
                {
                    montoCupon = cupon.monto;
                }

                if(paquete != null && evento != null)
                {
                    const monedaSymbol = getMonedaSymbol(evento.monedaId);
                    montoConDescuento = paquete.monto - montoCupon;

                    return {
                        precioText: `${monedaSymbol} ${paquete.monto}`,
                        precioConDescuentoText: `${monedaSymbol} ${montoConDescuento >= 0 ? montoConDescuento : 0}`,
                        precio: montoConDescuento >= 0 ? montoConDescuento : 0
                    };
                }                
            }
            return null;
        };

        function getEvento(eventoId){
            return vm.eventos.find((evento) => {
                return evento.id == eventoId;
            });
        };

        function doFormValidations()
        {
            validateSelectProperty($scope.dataForm, vm.data, 'eventoId' );
            validateSelectProperty($scope.dataForm, vm.data, 'bancoId' );
            validateSelectProperty($scope.dataForm, vm.data, 'metodoPagoId' );
        };

        vm.save = function(){

            $scope.submitted = true;

            doFormValidations();

            if($scope.dataForm.$valid){
                if(vm.data.id && $scope.dataForm.$dirty){
                    update();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function update(){
            ApiBaseService.remoteController = apiInscripciones + '/Pago';
            var promise = ApiBaseService.update(vm.data);
            
            promise
            .then(function(response){
                logger.success('Condirmación de Pago realizada.');

                if(vm.uiData.esOrganizador)
                {
                    $location.path('/editar-inscripcion');
                }
                else{
                    $location.path('/inscripciones');
                }
                
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function validateSelectProperty(form, object, property){
            if(object[property] == 0){
                form[property].$setValidity("different", false);
                return false;
            }
            else{
                form[property].$setValidity("different", true);
                return true;
            }
        };

        vm.onSelectChanged = function(property){

            switch (property) {
                case "eventoId":
                    onEventoIdChanged(property);
                    break;
                case "bancoId":
                    onBancoIdChanged(property);
                    break;
                case "metodoPagoId":
                    onTipoDepositoIdChanged(property);
                    break;
                default:
                    break;
            }
        };

        function onEventoIdChanged(property)
        {
            var result = validateSelectProperty($scope.dataForm, vm.data, property );

            if(result)
            {
                vm.data.precio = getPrecioEvento(vm.data.eventoId);
            }
            else{
                vm.data.precio = '0';
            }
        };

        function onBancoIdChanged(property)
        {
            validateSelectProperty($scope.dataForm, vm.data, property );
        };

        function onTipoDepositoIdChanged(property)
        {
            validateSelectProperty($scope.dataForm, vm.data, property );

            if(vm.data.metodoPagoId === TIPO_PAGO_EFECTIVO)
            {
                vm.data.bancoId = BANCO_NO_APLICA;
                vm.data.referenciaDeposito = 'NO APLICA';
            }
            else
            {
                vm.data.bancoId = 0;
                vm.data.referenciaDeposito = '';
            }
        };
    }
})();